import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "index-status",
  "use": "index-status-usage",
  "viewBox": "0 0 12 13",
  "content": "<symbol viewBox=\"0 0 12 13\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" id=\"index-status\">\n<circle cx=\"5.83898\" cy=\"6.8048\" r=\"5.83898\" fill=\"currentColor\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol